function parseInvoiceCalendarDate(raw) {
  if (raw == null || raw === "") return null;
  const text = String(raw).trim();
  const match = text.match(/^(\d{4})-?(\d{2})-?(\d{2})(?:$|T)/);
  const french = text.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  const parts = match ? [+match[1], +match[2], +match[3]] : french ? [+french[3], +french[2], +french[1]] : null;
  if (!parts) return null;
  const [year, month, day] = parts;
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
}
export function invoiceDueDate(invoice) {
  return parseInvoiceCalendarDate(invoice?.DateEcheance || invoice?.dateEcheance || invoice?.dueDate);
}
export function invoiceIssueDate(invoice) {
  return parseInvoiceCalendarDate(invoice?.dateFacture || invoice?.DateFacture);
}
export function isInvoiceOverdue(invoice, now = new Date()) {
  if (invoice.FactureRegle === 'OUI') return false;
  if (invoice.montantRestant != null && String(invoice.montantRestant).trim() !== '' && Number(String(invoice.montantRestant).replace(',', '.')) <= 0) return false;
  const due = invoiceDueDate(invoice);
  if (!due) return false;
  const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
  const key = `${due.getFullYear()}-${String(due.getMonth() + 1).padStart(2, '0')}-${String(due.getDate()).padStart(2, '0')}`;
  return key < today;
}
export function invoicePaymentLabel(invoice) {
  if (invoice.FactureRegle === 'OUI') return 'Payée';
  if (isInvoiceOverdue(invoice)) return 'Impayée';
  if (invoice.FactureRegle === 'PARTIEL') return 'Partielle';
  return invoiceDueDate(invoice) ? 'À régler' : 'Échéance non renseignée';
}
